<!--
  The contents of this file are subject to the license and copyright
  detailed in the LICENSE_ATMIRE and NOTICE_ATMIRE files at the root of the source
  tree and available online at

  https://www.atmire.com/software-license/
 -->
<ng-container *ngVar="(breadcrumbs$ | async) as breadcrumbs">
  <nav *ngIf="(showBreadcrumbs$ | async)" aria-label="breadcrumb" class="nav-breadcrumb">
    <ol class="container breadcrumb">
      <ng-container
        *ngTemplateOutlet="breadcrumbs?.length > 0 ? breadcrumb : activeBreadcrumb; context: {text: '', url: '/'}">
        <i class="fa fa-home" aria-hidden="true"></i>
      </ng-container>
      <ng-container *ngFor="let bc of breadcrumbs; let last = last;">
        <ng-container *ngTemplateOutlet="!last ? breadcrumb : activeBreadcrumb; context: bc"></ng-container>
      </ng-container>
    </ol>
  </nav>

  <ng-template #breadcrumb let-text="text" let-url="url">
    <li class="breadcrumb-item">
      <a [routerLink]="url">
        <i *ngIf="text === ''; else normal" class="fa fa-home my-auto" aria-hidden="true"></i>
        <ng-template #normal>{{ text | translate }}</ng-template>
      </a>
    </li>
  </ng-template>

  <ng-template #activeBreadcrumb let-text="text">
    <li class="breadcrumb-item active" aria-current="page">{{ text | translate }}</li>
  </ng-template>
</ng-container>
